import PropTypes from "prop-types";
import TitleWithCloseButton from "../TitleWithCloseButton";
import { Container, Dialog, DialogTitle, DialogActions, DialogContent } from "@cti-workspace/ui";

const ActionDialog = ({ open, onClose, title, content, primaryAction, secondaryAction, preventClosing = false, maxWidth = "xs" }) => {
	return (
		<Dialog open={open} onClose={onClose} disableBackdropClick={preventClosing} disableEscapeKeyDown={preventClosing} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description" maxWidth={maxWidth}>
			<DialogTitle>
				<TitleWithCloseButton title={title} variant={"h6"} onCLose={onClose} />
			</DialogTitle>
			<Container>
				<DialogContent>{content}</DialogContent>
			</Container>
			<DialogActions>
				{secondaryAction}
				{primaryAction}
			</DialogActions>
		</Dialog>
	);
};

ActionDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	content: PropTypes.element.isRequired,
	secondaryAction: PropTypes.element,
	primaryAction: PropTypes.element,
};

export default ActionDialog;
